
import { MA2Strategy } from './MA2Strategy';
import { MA3Strategy } from './MA3Strategy';

export class AutocompleteFactory {
    static create(version, keywordsData, monaco) {
        if (version === "MA3") {
            return new MA3Strategy(keywordsData, monaco);
        }
        return new MA2Strategy(keywordsData, monaco);
    }
}
